import React, { useState, useCallback, useEffect } from 'react';
import {
  List, TextField, Button, FormGroup, Autocomplete,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import { useStyles } from '../../components/Styles';

export default function HandleParameters(data) {
  const [newParameter, setNewParameter] = useState(null);
  const [newParameterId, setNewParameterId] = useState('');
  const [newTolerance, setNewTolerance] = useState('');
  const [options, setOptions] = useState([]);
  const [check, setCheck] = useState(false);
  const classes = useStyles();
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const lista = data.parameters;
  const [adicionados, setAdicionados] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setOptions(data.options);
  }, [data.options]);

  // Função que adiciona um objeto parâmetro em protocolos
  async function addOption() {
    if (newParameter !== null) {
      const pivot = options;
      pivot.push({
        parameter_id: newParameter.id,
        tolerance: newTolerance,
        parameter_name: newParameter.name,
      });
      setNewTolerance('');
      setNewParameter(null);
      setOptions(pivot);
      setAdicionados([...adicionados, newParameter]);
      data.callback(pivot);
      forceUpdate();
    }
  }

  // Função que deleta o objeto parâmetro escolhido
  async function deleteOption(option, i) {
    const newList = options;

    const obj = {
      parameter_id: options[i].parameter_id,
      protocol_id: id,
    };

    newList.splice(i, 1);
    const aux = [...adicionados];
    aux.splice(i, 1);
    setAdicionados(aux);
    setOptions(newList);
    forceUpdate();
  }

  // Função que atualiza o objeto parâmetro escolhido
  async function updateOption(value, i) {
    try {
      if (id) {
        setCheck(false);
      }
    } catch (err) {

    }

    forceUpdate();
  }

  function selecionarItem(item) {
    const options = adicionados;
    options.push(item);
    setAdicionados(options);
  }

  return (
    <FormGroup>
      <List dense align="center">
        <div>
          <h2>
            <strong>Adicionar Parâmetro</strong>
          </h2>
        </div>
        <ListItem dense>

          <Autocomplete
            options={lista}
            getOptionLabel={(option) => option.name}
            getOptionDisabled={(option) => !!adicionados.find((element) => element === option)}
            value={newParameter}
            style={{ width: '100%' }}
            onChange={(p, v) => {
              if (v) setNewParameter(v);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Parametros" variant="outlined" />
            )}
          />

          <TextField
            className={classes.textField}
            fullwidth
            label="Tolerancia"
            variant="outlined"
            name="newTolerance"
            type="number"
            min="0"
            inputProps={{
              min: 0,
            }}
            value={newTolerance}
            onChange={(e) => setNewTolerance(e.target.value)}
          />

          <Button
            onClick={addOption}
            disabled={newParameterId.legth === 0 || newTolerance.length === 0}
          >
            <AddIcon />
          </Button>

        </ListItem>
        {options && options.length > 0 && (
          <div>
            <h2>
              <strong> Parâmetros Adicionados</strong>
            </h2>
          </div>
        )}
        {options.map((option, i, old) => (
          <ListItem key={i}>
            <TextField
              className={classes.textField}
              // select
              margin="dense"
              type="text"
              variant="outlined"
              fullWidth
              value={option.parameter_name}
              onChange={(e) => {
                // updateOption(e.target.value, i)
              }}
            />
            <TextField
              className={classes.textField}
              margin="dense"
              type="number"
              min="0"
              fullWidth
              variant="outlined"
              value={option.tolerance}
              onChange={(e) => {
                option.tolerance = parseInt(e.target.value);
                setCheck(true);
                forceUpdate();
              }}
            />

            <Button onClick={() => deleteOption(option, i)}>
              <DeleteIcon />
            </Button>
            {check && id && (
              <Button onClick={() => updateOption(option, i)}>
                <CheckIcon />
              </Button>
            )}
          </ListItem>
        ))}
      </List>
    </FormGroup>
  );
}
